module.exports = __webpack_public_path__ + "img/infibo-system-scheme-en.29aa41d4.png";